/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompletionMessage, FileUpload } from '@app-libs/model';
import { WelcomeMessageComponent } from '../welcome-message/welcome-message.component';
import { MessageListComponent } from '../message-list/message-list.component';

@Component({
  selector: 'app-message-container',
  standalone: true,
  imports: [CommonModule, WelcomeMessageComponent, MessageListComponent],
  templateUrl: './message-container.component.html',
  styleUrls: ['./message-container.component.scss'],
  // Removed OnPush for streaming compatibility
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageContainerComponent {
  @ViewChild('messagesWrapper', { static: false }) messagesWrapper!: ElementRef<HTMLElement>;

  @Input() messages: CompletionMessage[] = [];
  @Input() showWelcomeMessage = false;
  @Input() welcomeMessage = '';
  @Input() activeMessageId: string | null = null;
  @Input() copiedMessageId = '';
  @Input() exportedMessageId = '';

  @Output() welcomeClick = new EventEmitter<MouseEvent>();
  @Output() copySuccess = new EventEmitter<CompletionMessage>();
  @Output() exportSuccess = new EventEmitter<CompletionMessage>();
  @Output() exportError = new EventEmitter<{ message: CompletionMessage; error: string }>();
  @Output() messageEnter = new EventEmitter<string | null>();
  @Output() messageLeave = new EventEmitter<void>();
  @Output() messageClick = new EventEmitter<CompletionMessage>();
  @Output() messageMouseDown = new EventEmitter<CompletionMessage>();
  @Output() messageMouseUp = new EventEmitter<CompletionMessage>();
  @Output() deleteFile = new EventEmitter<FileUpload>();

  onWelcomeClick(event: MouseEvent): void {
    this.welcomeClick.emit(event);
  }

  onCopySuccess(message: CompletionMessage): void {
    this.copySuccess.emit(message);
  }

  onExportSuccess(message: CompletionMessage): void {
    this.exportSuccess.emit(message);
  }

  onExportError(event: { message: CompletionMessage; error: string }): void {
    this.exportError.emit(event);
  }

  onMessageEnter(messageId: string | null): void {
    this.messageEnter.emit(messageId);
  }

  onMessageLeave(): void {
    this.messageLeave.emit();
  }

  onMessageClick(message: CompletionMessage): void {
    this.messageClick.emit(message);
  }

  onMessageMouseDown(message: CompletionMessage): void {
    this.messageMouseDown.emit(message);
  }

  onMessageMouseUp(message: CompletionMessage): void {
    this.messageMouseUp.emit(message);
  }

  onDeleteFile(file: FileUpload): void {
    this.deleteFile.emit(file);
  }
}
